// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mentions-container {
  width: 100%;
  padding: 2rem 3.5rem;
}

.mentions-container h1 {
  margin-bottom: 3rem;
}

.mentions-content {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  background: #fffdfc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.mentions-content.fullpage {
  height: calc(100vh - 240px); /* Ajustez cette valeur si nécessaire pour avoir le plein écran */
}

.mentions-body {
  padding: 0;
  height: 100%;
}

.mentions-iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Aide/Aide.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B,EAAE,iEAAiE;AAChG;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".mentions-container {\n  width: 100%;\n  padding: 2rem 3.5rem;\n}\n\n.mentions-container h1 {\n  margin-bottom: 3rem;\n}\n\n.mentions-content {\n  display: flex;\n  flex-direction: column;\n  margin-top: 2rem;\n  background: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.mentions-content.fullpage {\n  height: calc(100vh - 240px); /* Ajustez cette valeur si nécessaire pour avoir le plein écran */\n}\n\n.mentions-body {\n  padding: 0;\n  height: 100%;\n}\n\n.mentions-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
